import { config, gameState } from '@js/state';
import { enablePointerEvents, disablePointerEvents } from '@utils/pointer-events-control';

export default class StartScene extends Phaser.Scene {
  constructor() {
    super({
      key: "StartScene",
    });
  }

  preload() {
      this.load.multiatlas("rewardAnim", "assets/EndSceneAssets/rewardAnim/rewardAnim.json", "assets/EndSceneAssets/rewardAnim");
    this.load.multiatlas("endConfetti", "assets/EndSceneAssets/confetti/confettiAnimNew.json", "assets/EndSceneAssets/confetti");
  }

  assetsLoad()
  {
    this.load.image("greenCircle", "assets/GameSceneAssets/greenCircle.png");
 
    this.load.image("numberlineDiv3", "assets/GameSceneAssets/numberlineSets/numberlineDiv3.png");
    this.load.image("numberlineDiv4", "assets/GameSceneAssets/numberlineSets/numberlineDiv4.png");
    this.load.image("numberlineDiv5", "assets/GameSceneAssets/numberlineSets/numberlineDiv5.png");
    this.load.image("numberlineDiv6", "assets/GameSceneAssets/numberlineSets/numberlineDiv6.png");
    this.load.image("numberlineDiv8", "assets/GameSceneAssets/numberlineSets/numberlineDiv8.png");
    this.load.image("numberlineDiv10", "assets/GameSceneAssets/numberlineSets/numberlineDiv10.png");
    this.load.image("numberlineDiv12", "assets/GameSceneAssets/numberlineSets/numberlineDiv12.png");
 
    this.load.image("numberline0and1", "assets/GameSceneAssets/numberline0and1.png");
 
    this.load.image("qBoard1", "assets/GameSceneAssets/qns/Q Board_1.png");
    this.load.image("qBoard2", "assets/GameSceneAssets/qns/Q Board_2.png");
    this.load.image("qBoard3", "assets/GameSceneAssets/qns/Q Board_3.png");
    this.load.image("qBoard4", "assets/GameSceneAssets/qns/Q Board_4.png");
    this.load.image("qBoard5", "assets/GameSceneAssets/qns/Q Board_5.png");
    this.load.image("qBoard6", "assets/GameSceneAssets/qns/Q Board_6.png");
    this.load.image("qBoard7", "assets/GameSceneAssets/qns/Q Board_7.png");
    this.load.image("qBoard8", "assets/GameSceneAssets/qns/Q Board_8.png");
    this.load.image("qBoard9", "assets/GameSceneAssets/qns/Q Board_9.png");
    this.load.image("qBoard10", "assets/GameSceneAssets/qns/Q Board_10.png");
 
    this.load.image("speechBubble1", "assets/GameSceneAssets/qns/question_1.png");
    this.load.image("speechBubble2", "assets/GameSceneAssets/qns/question_2.png");
    this.load.image("speechBubble3", "assets/GameSceneAssets/qns/question_3.png");
    this.load.image("speechBubble4", "assets/GameSceneAssets/qns/question_4.png");
    this.load.image("speechBubble5", "assets/GameSceneAssets/qns/question_5.png");
    this.load.image("speechBubble6", "assets/GameSceneAssets/qns/question_6.png");
    this.load.image("speechBubble7", "assets/GameSceneAssets/qns/question_7.png");
    this.load.image("speechBubble8", "assets/GameSceneAssets/qns/question_8.png");
    this.load.image("speechBubble9", "assets/GameSceneAssets/qns/question_9.png");
    this.load.image("speechBubble10", "assets/GameSceneAssets/qns/question_10.png");
  }

  create() {
    // Enable pointer events so hover states and the cursor work
    enablePointerEvents();

    disablePointerEvents();
    config.audio.bgaudio = this.sound.add("bgaudio");
    config.audio.heliaudio = this.sound.add("heliaudio");

    this.add.sprite(config.width / 2, config.height / 2, "startSceneBG").setDisplaySize(1280, 720);

    this.add.sprite(config.width / 2, config.height / 2 - 40, "gameName").setScale(1);

    this.playButton = this.add
      .sprite(config.width / 2, config.height / 2 + 100, "playButton")
      .setScale(0.67)
      .setInteractive({ cursor: "pointer" });

      this.assetsLoad();
      this.load.start();  

    this.playButton.on(
      "pointerover",
      function (pointer) {
        //this.playButton.setTint(0xc4c4c4);
        this.playButton.setTexture("playHover");
      },
      this
    );
    this.playButton.on(
      "pointerout",
      function (pointer) {
        //this.playButton.setTint();
        this.playButton.setTexture("playButton");
      },
      this
    );

    this.heli = this.physics.add
      .sprite(625, config.height - 360, "heliAnim")
      .setScale(0.67)
      .setOrigin(0.5, 0.5);
    this.anims.create({
      key: "heliPlay",
      frames: this.anims.generateFrameNames("heliAnim", {
        start: 0,
        end: 30,
        zeroPad: 0,
        prefix: "helihomescreen",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: -1,
    });
    this.heli.play("heliPlay");

    this.playButton.on(
      "pointerup",
      function (pointer) {
        enablePointerEvents();
        config.audio.heliaudio.setLoop(true).setVolume(0.02).play();

        config.audio.bgaudio.setLoop(true).setVolume(0.02).play();

        this.playButton.disableInteractive();
        this.tweens.add({
          targets: this.heli,
          ease: "Sine.easeInOut",
          duration: 1000,
          y: {
            getStart: () => config.height - 360,
            getEnd: () => -50,
          },
          yoyo: false,
          loop: 0,
        });

        this.tweens.add({
          targets: this.heli,
          ease: "Sine.easeInOut",
          duration: 2200,
          delay: 1300,
          angle: {
            getStart: () => 0,
            getEnd: () => 30,
          },
          x: {
            getStart: () => 625,
            getEnd: () => 2000,
          },
        });

        this.tweens.add({
          targets: config.audio.heliaudio,
          volume: 0,
          duration: 3000,
          onComplete: () => {
            //heliaudio.setVolume(0);
          },
        });

        this.time.delayedCall(
          3500,
          function () {
            this.scene.stop("StartScene");

            this.scene.start("TutorialScene");

            //this.scene.start("EndScene");

            //config.audio.heliaudio  = this.sound.add('heliaudio');

            //this.scene.start("GameScene");
          },
          [],
          this
        );
      },
      this
    );
  }

  update() {}
}
